<div class="subscription-block">
	<div class="subscription-block-right">
		<button class="exit-button-icon" [disableRipple]="true" (click)="closeDialog()"
			type="button" mat-icon-button>
			<mat-icon svgIcon="md:close"></mat-icon>
		</button>
	</div>
	<div class="subscription-title">
		<div translate>user.notifications.dialog.subscription</div>
	</div>
	<div class="subscription-dropdown">
		<span class="dropdown-label" translate>user.notifications.dropdown.services</span>
		<mat-form-field floatLabel="always">
			<mat-label translate>user.notifications.select.service</mat-label>
			<mat-select [(value)]="selectedServiceId" (selectionChange)="serviceChanged()">
				<mat-option class="option-selected" *ngFor="let services of servicesSubscriptions" [value]="services.id">
					{{ services.name }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="subscription-dropdown">
		<span class="dropdown-label" translate>user.notifications.dropdown.subscription</span>
		<mat-form-field floatLabel="always">
		<mat-label translate>user.notifications.select.subscription</mat-label>
			<mat-select [(value)]="selectedSubscriptionId" (selectionChange)="subscriptionChanged($event)">
				<mat-option class="option-selected" *ngFor="let subs of subscriptions" [value]="subs.subscriptionId">
					{{ subs.subscriptionName }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="subscription-dropdown">
		<span class="dropdown-label" translate>user.notifications.dropdown.frequency</span>
		<mat-form-field floatLabel="always">
		<mat-label translate>user.notifications.select.frequency</mat-label>
			<mat-select [(value)]="selectedFrequency">
				<mat-option class="option-selected" *ngFor="let frequency of frequencies" [value]="frequency">
					{{ frequency }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="add-subscription-btn">
		<button type="submit" cdkFocusInitial mat-flat-button (click)="sendNotification()"
			color="primary"
			mat-ripple>
			<span translate>user.notifications.add.subscription</span>
		</button>
	</div>
</div>
